// 本地开发/联调默认环境（dev）。
// 后端走 freeoa customer BFF 的 OrbStack HTTPS 域名（避免 https 前端调 http 后端被浏览器按混合内容拦截）。
// 生产（Cloudflare Workers）构建由 angular.json production 配置替换为 environment.prod.ts。
export const environment = {
  production: false,
  customerBaseUrl: 'https://customer.edge.orb.local',
};
